import Cookies from 'js-cookie';
import actions from './actions';

const {
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_ERR,
  VERIFY_TWO_BEGIN,
  VERIFY_TWO_SUCCESS,
  VERIFY_TWO_ERR,
  CHANGE_PASSWORD_BEGIN,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERR,
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_ERR,
} = actions;

const initState = {
  login: Cookies.get('logedIn'),
  loading: false,
  error: null,
  success: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
        error: null,
      };
    case LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
      case VERIFY_TWO_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case VERIFY_TWO_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
        error: null,
      };
    case VERIFY_TWO_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case CHANGE_PASSWORD_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        login: false,
        loading: false,
        error: null,
        success:data?.message,
      };
    case CHANGE_PASSWORD_ERR:
      return {
        ...state,
        error:err,
        loading: false,
        success: null,
      };
    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        login: false,
        loading: false,
        error: null,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        login: false,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default AuthReducer;
